import React from 'react';
import styled from '@emotion/styled';
import PhoneInput, { DefaultInputComponentProps, State, Props, type Value } from 'react-phone-number-input';

type PhoneInputProps = React.ComponentProps<typeof PhoneInput>;
interface CustomPhoneInputProps extends Omit<PhoneInputProps, 'onChange'> {
  onChange: (value: Value) => void;
  value?: Value;
}

const StyledPhoneInput = styled(PhoneInput)`
  display: flex;
  width: 100%;
`;

const StyledInput = styled.input`
  flex-grow: 1;
`;

const StyledFlag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  height: 16px;
  line-height: 0;
`;

const getCountryEmoji = (countryCode: string = '') => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map((char) => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

const InputComponent = React.forwardRef(
  (
    props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
    ref: React.Ref<HTMLInputElement>
  ) => {
    return <StyledInput {...props} className="ant-input" ref={ref} />;
  }
);

const FlagComponent: PhoneInputProps['flagComponent'] = ({ country }) => (
  <StyledFlag>{getCountryEmoji(country)}</StyledFlag>
);

const PhoneInputComponent = React.forwardRef<
  React.Component<Props<DefaultInputComponentProps>, State<Props<DefaultInputComponentProps>>>,
  CustomPhoneInputProps
>((props, ref) => (
  <StyledPhoneInput
    ref={ref}
    inputComponent={InputComponent}
    flagComponent={FlagComponent}
    onChange={props.onChange}
    value={props.value}
    {...props}
  />
));

export default PhoneInputComponent;
